import { IonIcon } from '@ionic/react';
import { lockClosed } from 'ionicons/icons';
import { ReactElement } from 'react';
import './ui.css';

interface FieldLockedProps {
  show: boolean;
}

const FieldLocked = (props: FieldLockedProps): ReactElement | null => {
  const { show } = props;
  if (show) {
    return <IonIcon className="field-locked-icon" icon={lockClosed} />;
  }
  return null;
};

export { FieldLocked };
